'use client';

import { CustomImage } from 'components/shared/custom-image/CustomImage';
import styles from './HowItWorks.module.css';

/**
 * The artwork + numbered badge of one How-it-works card.
 *
 * The only reason this is a client island: CustomImage hands next/image a
 * `loader` function, and next/image is itself a Client Component, so the prop
 * would cross a server→client boundary and throw at runtime. Isolating the two
 * images here keeps the section, its heading and all of its copy on the server.
 * Same trap as the three route shells named in
 * docs/app-router-migration/02-rendering-and-data-fetching.md.
 */

type StepShotProps = {
  src: string;
  alt: string;
  /** 1-based; picks the matching numeral asset. */
  step: number;
};

const StepShot = ({ src, alt, step }: StepShotProps) => (
  <div className={styles.shotWrap}>
    <CustomImage
      className={styles.shot}
      src={src}
      alt={alt}
      width={312}
      height={335}
      loading="lazy"
    />
    <div className={styles.badgeSlot} aria-hidden="true">
      <CustomImage
        className={styles.stepBadge}
        src={`web_v2/pulsomics-1/steps/num${step}.png`}
        alt=""
        width={32}
        height={32}
      />
    </div>
  </div>
);

export default StepShot;
